module.exports = __webpack_public_path__ + "img/default-student-img.229ee64f.png";